import { NavMenuKeys } from '@/routes/navMenu';
import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
import { type Route } from '@/routes/route';

const { Page } = lazyImport(() => import('../index'), 'Page');
// 该页面的路由，以及所属那个模块
export const routes: Route[] = [
  {
    name: '会员中心',
    path: '/member/users',
    element: <Page />,
    module: NavMenuKeys.Member,
    layout: 'BasicLayout',
    enable: true,
    order: 1,
  },
];
